module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external "TemplatesCommonLib/baseClasses/ApplicationBase"
// module id = 9
// module chunks = 0